module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/logo-a0f50a2cf319a1b8cb1f21fdf1500894.png";